/** Patient-facing forms routes with no CRM chrome or staff realtime. */
export function isStandalonePatientFormsPath(pathname: string): boolean {
  return pathname === '/forms/public' || pathname === '/forms/kiosk'
}

export { isKioskDeviceMode } from '@utils/kioskFormsUrl.util'
